export const mockGeocodedLocation = {
  latitude: 40.783829,
  longitude: -73.97537
};

export default mockGeocodedLocation;
